import { VehiclesPopoverController } from './vehiclesPopoverController';

export class VehiclesController {
  constructor(parent, mapView, key, info) {
    this._parent = parent;
    this._key = key;
    this._mapView = mapView;
    this._info = info;
    this._tween = swim.Transition.duration(350);
    this._vehiclesColor = { default:'#44D7B6', dim: '#9c9d9f', ban: '#ff8c00', crash:'#F6511D', tag: '#F9F070' };
    this._popoverView = null;

    // Data
    this._lng = { value: 0, dirty: true };
    this._lat = { value: 0, dirty: true };
    this._color = '#fff';
    this._tag = false;
    this._crash = false;
    this._ban = false;

    this._isRipple = false;

    // Create Marker on map
    this._marker = new swim.MapCircleView()
      .center([info.get("longitude").numberValue(0), info.get("latitude").numberValue(0)])
      .radius(5)
      .fill(swim.Color.transparent());

    this._mapView.view.setChildView(this._key, this._marker);
    this._marker.on("click", this.onClickVehicle.bind(this));

    this.update(info);
  }

  get view() {
    return this._marker;
  }

  get color() {
    return this._color;
  }

  update(info) {
    this._info = info;

    const lng = info.get("longitude").numberValue(0);
    if(lng !==  this._lng.value) {
      this._lng.value = lng;
      this._lng.dirty = true;
    }
    const lat = info.get("latitude").numberValue(0);
    if(lat !==  this._lat.value) {
      this._lat.value = lat;
      this._lat.dirty = true;
    }

    const crash = info.get('crash').stringValue();
    this._crash = (crash === 'true');

    const ban = info.get('banAlert').stringValue();
    this._ban = (ban === 'true');


    const tag = info.get('noTagStatus').stringValue();
    this._tag = (tag === 'true');

  }

  render() {
    if(this._parent.noTag) {
      if(this._tag) {
        this._marker.fill(swim.Color.transparent());
      } else {
        this.setProperty();
      }
    } else {
      this.setProperty();
    }
  }

  setProperty() {
    // Dirty check if lng or lat change
    if(this._lng.dirty || this._lat.dirty) {
      this._marker.center([this._lng.value, this._lat.value], this._tween);
      this._lng.dirty = false;
      this._lat.dirty = false;
    }


    let color = null;

    // Color Logic for Vehicle
    if (!document.hidden && this._crash && this._parent.showCrush) {
      this.ripple(this._lng.value, this._lat.value);
      color = this._vehiclesColor.crash;
    } else if(this._ban && this._parent.showBan) {
      color = this._vehiclesColor.ban;
    } else if(!this._tag && this._parent.noTag || this._info.get('status').stringValue() !== 'ACTIVE' ) {
      color = this._vehiclesColor.tag;
    } else {
      color = (this._parent.noTag || this._parent.showCrush)? this._vehiclesColor.dim : this._parent.vehicleColor;
    }

    this._color = color;
    this._marker.fill(color);

  }

  ripple(lng, lat) {

    if(!this._isRipple) {
      this._isRipple = true;
      const RIPPLE_COLOR = swim.Color.parse("#f0f").alpha(0.5);
      const ripple = new swim.MapCircleView()
        .center([lng, lat])
        .radius(0)
        .fill(null)
        .stroke(RIPPLE_COLOR)
        .strokeWidth(1);
      this._mapView.view.append(ripple);
      const radius = Math.min(this._mapView.view.bounds.width, this._mapView.view.bounds.height) / 8;
      const tween = swim.Transition.duration(2000);
      ripple.stroke(RIPPLE_COLOR.alpha(0), tween)
      .radius(radius, tween.onEnd( ()=> {
        ripple.remove();
        this._isRipple = false;
      }));
    }
  }

  // On click event create popover
  onClickVehicle(event) {
    event.stopPropagation();
    this.setPopover();
  }

  setPopover() {
    if (!this._popoverView) {
      this._popoverView = new VehiclesPopoverController(this, this._marker, this._info);
    }

    this._popoverView.update(this._info);
    this._mapView.appView.togglePopover(this._popoverView.view, {multi: event.altKey});
  }

  remove() {
    if(this._popoverView) {
      this._popoverView._popoverView.remove();
    }
    this._marker.remove();
  }
}
